import React, { useState, useEffect } from "react";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import BUDGET_API from "../../../../../apis/budget.api";
import plaidIcon from "../../../../../assets/images/budget/plaidlogo.png";
import DEATH_API from "../../../../../apis/death.api";
import { Modal, Table } from "antd";
import {  Button, Dropdown, Menu, Select, Icon  } from "antd";
import menuIcon from "../../../../../assets/images/DeathModuleNew/Menu.png"
import swal from "sweetalert";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { AddRecurringPattren } from "../../RecurringPattren/RecurringModals/AddRecurringPattren";
import { AddRecurringPatternModalFromTable } from "./AddRecurringPatterenModalFromTable";
import { EditRecurringPatternModalFromTable } from "./EditRecurringPatternModalFromTable";

const RecurringCombined = ({fetchSystemRecurringPages, setAllTransactions,allTransactions, systemRecurringTransactions, hideRecurringTransaction, deleteRecurringTransaction, deleteToken, getRecurringTransactionsData, systemTotalPages, currentPage, setCurrentPage, selectedRowsDataKeys, selectedRowKeys}) => {

    const [totalPages, setTotalPages] = useState(1);
    // const [currentPage, setCurrentPage] = useState(1);
    const [recurringTransactions, setRecurringTransactions] = useState([]);
    const [cachedData, setCachedData] = useState({});
    const [loading, setLoading] = useState(false);
    const [detailsModal, setDetailsModal] = useState(false);
    const [selectedObject, setSelectedObject] = useState([]); 
    const [unifiedList, setUnifiedList] = useState([]);
    const [addModal, setAddModal] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [formData, setFormData] = useState(null);
    const [modalTitle, setModalTitle] = useState("Add Rule");
    const [fetchRecuuring, setFetchRecuuring] = useState(false);
    const [recurring, setRecurring] = useState(false);
    const [recurringTokens, setRecurringTokens] = useState([]);

    const [pattrenModal, setPattrenModal] = useState(false);
    const [tokenModal, setTokenModal] = useState(false);
    const [selectecPrediction, setSelectedPrediction] = useState({})
    const [currentTokenPage, setCurrentTokenPage] = useState(1);
    const [totalTokenPages, setTotalTokenPages] = useState(1);
    const [totalTokenRecords, setTotalTokenRecords] = useState(0);
      

  const [displayList, setDisplayList] = useState([]);
  const [systemCache, setSystemCache] = useState({});
  // const [systemTotalPages, setSystemTotalPages] = useState(1);
  const [systemRawData, setSystemRawData] = useState([]);
  const [count, setCount] = useState(0)

  const history = useHistory();

  const PAGE_SIZE = 20;

    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

    const sortedData =
      selectedObject &&
      selectedObject.length > 0 &&
      [...selectedObject].sort((a, b) => {
        if (sortConfig.key === "date") {
          return sortConfig.direction === "asc"
            ? new Date(a.date) - new Date(b.date)
            : new Date(b.date) - new Date(a.date);
        } else if (sortConfig.key === "amount") {
          return sortConfig.direction === "asc"
            ? a.amount - b.amount
            : b.amount - a.amount;
        }
        return 0;
      });

    // useEffect(() => {
    //   if(allTransactions){
    //     setRecurringTransactions(allTransactions)
    //   }
    // }, [allTransactions]);

    // const getSystemPage = async (page) => {
    //   if (systemCache[page]) return systemCache[page];
  
    //   const response = await BUDGET_API.fetchSystemRecurringTransactions(page);
    //   console.log('ress----------------',count,page,currentPage,response)
    //   setCount(count+1)
    //   if (response && response.data && response.data.transactions) {
    //     setSystemCache((prev) => ({ ...prev, [page]: response.data.transactions }));
    //     setSystemTotalPages(response.data.totalPages || 1);
    //     return response.data.transactions;
    //   }
    //   return [];
    // };
  
    const mapSystem = (systemData) => {
      return systemData.map((item) => {
        const rawDate = item.transaction && item.transaction.date || null;
        const isoDate = rawDate ? new Date(rawDate).toISOString() : null;
        return {
          id: item.recurringToken && item.recurringToken.id || null,
          itemName: item.recurringToken && item.recurringToken.token || "N/A",
          occurance: item.totalTransactions || "N/A",
          bankName: item.transaction && item.transaction.account || "N/A",
          amount: item.transaction && item.transaction.amount ?  item.transaction.amount : "N/A",
          accountType: item.transaction && item.transaction.accountType || "N/A",
          accountNumber: item.transaction && item.transaction.accountNumber || "N/A",
          frequency: item.recurringToken && item.recurringToken.frequency || "N/A",
          dueDate: isoDate,
          itemLogo: null,
          status: "Confirmed",
          token: item.recurringToken && item.recurringToken.token || "",
          recurring_patterns: item.recurringToken && item.recurringToken.patterns.length > 0 ? item.recurringToken.patterns : [],
        };
      });
    };
  
    const mapPrediction = (predictions) => {
      return predictions.map((item) => {
        const rawDate = item.date || null;
        const isoDate = rawDate ? new Date(rawDate).toISOString() : null;
        return {
          id: item.id || null,
          itemName: item.itemName || "N/A",
          occurance: item.occurance || "N/A",
          bankName: item.bankName || "N/A",
          amount: item.amount ? item.amount : "N/A",
          accountType: item.accountType || "N/A",
          accountNumber: item.accountNumber || "N/A",
          frequency: item.frequency || "N/A",
          dueDate: isoDate,
          itemLogo: item.itemLogo || null,
          status: item.frequency && item.frequency.toLowerCase() === "irregular" ? "Needs Review" : "Predicted",
          hidden: item.hasOwnProperty("hidden") ? item.hidden : false,
        };
      });
    };
  
    const mergeAndSlice = async () => {
      setLoading(true);
      try {
        const start = (currentPage - 1) * PAGE_SIZE;
        const end = start + PAGE_SIZE;
        if(allTransactions){
      
          // let systemItems = [];
          // let page = 1;
      
          // // Keep fetching system pages until we have enough items
          // while (systemItems.length < end && page <= systemTotalPages) {
          //   const pageData = await getSystemPage(page);
          //   systemItems = [...systemItems, ...pageData];
          //   page++;
          // }
    
          setSystemRawData(systemRecurringTransactions && systemRecurringTransactions.length ? systemRecurringTransactions : []); // update for total calculation
      
          const mappedSystem = mapSystem(systemRecurringTransactions ? systemRecurringTransactions : []);
          const mappedPrediction = mapPrediction(allTransactions && allTransactions);
      
          const fullCombined = [...mappedSystem, ...mappedPrediction];
          const sortedCombined = fullCombined.sort((a, b) => new Date(b.dueDate) - new Date(a.dueDate));
          const paginated = sortedCombined.slice(start, end);
      
          setDisplayList(paginated.filter(item => item.hidden !== true));
        }else{
          setSystemRawData(systemRecurringTransactions && systemRecurringTransactions.length ? systemRecurringTransactions : []);
          const mappedSystem = mapSystem(systemRecurringTransactions ? systemRecurringTransactions : []);
          const fullCombined = [...mappedSystem];
          const sortedCombined = fullCombined.sort((a, b) => new Date(b.dueDate) - new Date(a.dueDate));
          const paginated = sortedCombined.slice(start, end);
      
          setDisplayList(paginated.filter(item => item.hidden !== true));
        }
      } catch (e) {
        console.error("Pagination error:", e);
      } finally {
        setLoading(false);
      }
    };


    useEffect(() => {
      const combinedLength = systemRawData.length + (allTransactions ? allTransactions.length : 0);
      const total = Math.ceil(combinedLength / PAGE_SIZE);
      setTotalPages(total); //  updates pagination display
    }, [systemRawData, allTransactions, systemRecurringTransactions]);
  
    useEffect(() => {
      // if (allTransactions && allTransactions.length > 0) {
        mergeAndSlice();
      // }
    }, [allTransactions, currentPage, systemRecurringTransactions]);
  

    // useEffect(() => {
    //     const fetchSystemRecurring = async (page) => {
    //       try {
    //         const data = await BUDGET_API.fetchSystemRecurringTransactions(page);
    //         const systemData = data && data.data && data.data.transactions || [];
    
    //         // Map system recurring transactions
    //         const mappedSystem = systemData.map((item) => {
    //           const rawDate = item.transaction && item.transaction.date || null;
    //           const isoDate = rawDate ? new Date(rawDate).toISOString() : null;
    //           return{
    //             id: item.recurringToken && item.recurringToken.id || null,
    //             itemName: item.recurringToken && item.recurringToken.token || "N/A",
    //             occurance: item.totalTransactions && item.totalTransactions || "N/A",
    //             bankName: item.transaction && item.transaction.account || "N/A",
    //             amount: item.transaction.amount ? item.transaction.amount : "N/A",
    //             accountType: item.transaction && item.transaction.accountType || "N/A",
    //             accountNumber: item.transaction && item.transaction.accountNumber || "N/A",
    //             frequency: item.recurringToken && item.recurringToken.frequency || "N/A",
    //             dueDate: isoDate,
    //             itemLogo: null,
    //             status: "Confirmed"
    //           }
    //         });
    
    //         // Map prediction transactions (from props)
    //         const mappedPrediction = allTransactions.map((item) => {
    //           const rawDate = item.transaction && item.transaction.date || null;
    //           const isoDate = rawDate ? new Date(rawDate).toISOString() : null;
    //           return{
    //             id: item.id || null,
    //             itemName: item.itemName || "N/A",
    //             occurance: item.occurance || "N/A",
    //             bankName: item.bankName || "N/A",
    //             amount: item.amount ? item.amount : "N/A",
    //             accountType: item.accountType || "N/A",
    //             accountNumber: item.accountNumber || "N/A",
    //             frequency: item.frequency || "N/A",
    //             dueDate: item.date || null,
    //             itemLogo: item.itemLogo || null,
    //             status: item.frequency.toLowerCase() === "irregular" ? "Needs Review" : "Predicted",
    //           }
    //         });
    
    //         // Combine both
    //         setUnifiedList([...mappedSystem, ...mappedPrediction]);
    //         console.log("unifiedList--------------------->>>>>",[...mappedSystem, ...mappedPrediction])
    //       } catch (error) {
    //         console.error("Error fetching system recurring data:", error);
    //       }
    //     };
    
    //     fetchSystemRecurring(currentPage);
    //   }, [allTransactions]);

      const getSortValue = (record) => {
        if (
          record.frequency &&
          record.frequency.toLowerCase() === "irregular"
        ) return Number.POSITIVE_INFINITY;
      
        if (!record.date) return Number.POSITIVE_INFINITY;
      
        const currentDate = new Date();
        const dueDate = new Date(record.date);
        let nextDueDate = new Date(dueDate);
      
        switch (record.frequency && record.frequency.toLowerCase()) {
          case "monthly":
            nextDueDate.setFullYear(currentDate.getFullYear());
            nextDueDate.setMonth(currentDate.getMonth());
            nextDueDate.setDate(dueDate.getDate());
      
            if (currentDate > nextDueDate) {
              nextDueDate.setMonth(nextDueDate.getMonth() + 1);
            }
            break;
      
          case "weekly":
            while (nextDueDate <= currentDate) {
              nextDueDate.setDate(nextDueDate.getDate() + 7);
            }
            break;
      
          case "yearly":
            nextDueDate.setFullYear(currentDate.getFullYear());
            nextDueDate.setMonth(dueDate.getMonth());
            nextDueDate.setDate(dueDate.getDate());
      
            if (currentDate >= nextDueDate) {
              nextDueDate.setFullYear(currentDate.getFullYear() + 1);
            }
            break;
      
          default:
            // Frequency unknown = expired
            return Number.NEGATIVE_INFINITY;
        }
      
        return nextDueDate.getTime(); // accurate for sorting
      };

      function calculateDueStatus(record) {
        const currentDate = new Date();
        let dueDate = new Date(record.dueDate);
      
        let nextDueDate = new Date(dueDate); // Start from the original due date
      
        switch (record.frequency) {
          case "Monthly":
            nextDueDate.setFullYear(currentDate.getFullYear());
            nextDueDate.setMonth(currentDate.getMonth());
            nextDueDate.setDate(dueDate.getDate());
      
            if (currentDate > nextDueDate) {
              nextDueDate.setMonth(currentDate.getMonth() + 1);
            }
            break;
      
          case "Weekly":
            while (nextDueDate <= currentDate) {
              nextDueDate.setDate(nextDueDate.getDate() + 7);
            }
            break;
      
          case "Yearly":
            nextDueDate.setFullYear(currentDate.getFullYear());
            nextDueDate.setMonth(dueDate.getMonth());
            nextDueDate.setDate(dueDate.getDate());
      
            if (currentDate >= nextDueDate) {
              nextDueDate.setFullYear(currentDate.getFullYear() + 1);
            }
            break;
      
          default:
            return "Expired";
        }
      
        if (dueDate.toDateString() === currentDate.toDateString()) {
          return "Today";
        } else if (dueDate < currentDate) {
          const timeDifference = nextDueDate.getTime() - currentDate.getTime();
          const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
          return `In ${daysDifference} days`;
        } else {
          const timeDifference = dueDate.getTime() - currentDate.getTime();
          const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
          return `In ${daysDifference} days`;
        }
      }

      const getSelectedRecords = async(record, page =1, limit=20) => {
        // setDetailsModal(true);
        console.log("record.predictionTransactions", record);
        setSelectedPrediction(record)
        if (record.id) {
         try {
          setLoading(true);
          if(record.status !== "Confirmed"){
            let data = await BUDGET_API.fetchAllRelatedTransaction(record.id);
            if (data && data) {
              setSelectedObject(data);
            }
          }else{
            let data1 = await BUDGET_API.fetchRecurringAppliedTransaction(
              record.id,
              page,
              limit
            );
            if (data1 && data1.data.transactions) {
              // setSelectedObject(data.data.transactions);
              const newData = data1.data.transactions.map(item => item.transaction)
              setSelectedObject((prevItems) => [
                ...prevItems,
                // ...data1.data.transactions,
                ...newData,
              ]);
              setTotalTokenPages(data1.data.totalPages);
              setTotalTokenRecords(data1.data.totalRecords);
              setCurrentTokenPage(page);
          }
        }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        }
      };

      const handleScroll = () => {
        const { scrollTop, scrollHeight, clientHeight } =
          document.getElementById("transactions-main");
        console.log("Scroll Top:", scrollTop);
        console.log("Scroll Height:", scrollHeight);
        console.log("Client Height:", clientHeight);
    
        if (scrollTop + clientHeight >= scrollHeight) {
          console.log("Bottom of the scroll reached.");
          console.log("pageee", currentTokenPage, totalTokenPages);
          if (currentTokenPage < totalTokenPages) {
            console.log("Fetching more items...");
            getSelectedRecords(
              selectecPrediction,
              currentTokenPage + 1,
              10
            );
          }
        }
      };

      const handleCancel = () => {
        setSelectedObject([]);
        setDetailsModal(false);
        setCurrentTokenPage(1);
        setTotalTokenPages(1);
        setTotalTokenRecords(0);
      };

      const renderSortIcon = (key) => {
        if (sortConfig.key !== key) return null; // No icon if the column is not sorted
    
        // Return both icons, with the appropriate one being active
        return (
          <>
            {sortConfig.direction === "asc" ? (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ color: "white", fontSize: "8px" }}>▲</span>{" "}
                {/* Upward arrow */}
                <span style={{ color: "gray", fontSize: "8px" }}>▼</span>{" "}
                {/* Downward arrow (inactive) */}
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ color: "gray", fontSize: "8px" }}>▲</span>{" "}
                {/* Upward arrow (inactive) */}
                <span style={{ color: "white", fontSize: "8px" }}>▼</span>{" "}
                {/* Downward arrow */}
              </div>
            )}
          </>
        );
      };

      const handleSort = (key) => {
        setSortConfig((prevConfig) => ({
          key,
          direction:
            prevConfig.key === key && prevConfig.direction === "asc"
              ? "desc"
              : "asc",
        }));
      };
    
      const cols = [
        {
          title: "Item",
          dataIndex: "itemName",
          sorter: (a, b) =>
            (a.itemName || a.token || "").localeCompare(
              b.itemName || b.token || ""
            ),
          render: (fileName, record) => {
            return record.itemName || record.token ? (
              <React.Fragment>
                <div
                  style={{
                    display: "flex",
                    gap: "6px",
                    cursor: "pointer",
                    alignItems: "center",
                  }}
                  onClick={() => {
                    setDetailsModal(true);
                    getSelectedRecords(record);
                  }}>
                  <img
                    style={{ borderRadius: "50%" }}
                    height={34}
                    width={34}
                    src={record.itemLogo ? record.itemLogo : plaidIcon}></img>
                  <div>
                    <div>{record.itemName || record.token}</div>
                    <div
                      style={{
                        color:
                          record.frequency &&
                          record.frequency.toLowerCase() === "irregular"
                            ? "red"
                            : "#2a3da3",
                        fontStyle:
                          record.frequency &&
                          record.frequency.toLowerCase() === "irregular" &&
                          "italic",
                        fontWeight: "bold",
                      }}>
                      {record.frequency && record.frequency}
                    </div>
                    {record.frequency &&
                      record.frequency.toLowerCase() !== "irregular" && (
                        <div
                          style={{ color: "#79797D", fontWeight: "lighter" }}>
                          {record.frequency.toLowerCase() === "monthly"
                            ? "1 Subscription"
                            : record.count &&
                              record.count + " " + "Subscriptions"}
                        </div>
                      )}
                  </div>
                </div>
              </React.Fragment>
            ) : (
              "N/A"
            );
          },
        },
        {
          title: "No. of Transactions",
          dataIndex: "occurance",
          sorter: (a, b) => {
            const occA = parseInt(a.occurance) || 0;
            const occB = parseInt(b.occurance) || 0;
            return occA - occB;
          },
          render: (fileName, record) => {
            return record.occurance ? <div>{record.occurance}</div> : "N/A";
          },
        },
        {
          title: "Bank",
          dataIndex: "bankName",
          sorter: (a, b) => (a.bankName || "").localeCompare(b.bankName || ""),
          render: (fileName, record) => {
            return record.bankName || record.accountName ? (
              <div>
                {record.accountVaired ? (
                  "Vaired"
                ) : (
                  <div>
                    <div>
                      {record.accountName
                        ? `${record.accountName}`
                        : record.bankName || ""}
                    </div>
                    {record.accountType && (
                      <span style={{ color: "black" }}>
                        {record.accountType}
                      </span>
                    )}
                  </div>
                )}
              </div>
            ) : record.paidUsing == "Cash" ? (
              "Cash"
            ) : (
              "N/A"
            );
          },
        },
        {
          title: "Amount",
          dataIndex: "amount",
          sorter: (a, b) => {
            const amountA = parseFloat(a.amount);
            const amountB = parseFloat(b.amount);
            // Toggle sorting order directly
            if (amountA < amountB) {
              return -1; // Sort in ascending order
            } else if (amountA > amountB) {
              return 1; // Sort in descending order
            } else {
              return 0; // Leave items unchanged if they are equal
            }
          },
          render: (fileName, record) => {
            const val =
              typeof record.amount === "number"
                ? `$${record.amount
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                : "N/A";
            return (
              <div
                style={{
                  width: "100%",
                  fontWeight: "bold",
                  // color: record < 0 ? "#00A27B" : "",
                  color: record.amount < 0 ? "black" : "#00A27B",
                }}>
                {record.amount
                  ? !isNaN(record.amount)
                    ? record.amountVaired
                      ? "Varied"
                      : `${
                          record.amount && record.amount < 0
                            ? "$" +
                              record.amount
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "$" +
                              record.amount
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }`
                    : "N/A"
                  : "N/A"}
              </div>
            );
          },
        },
        {
          title: "Account",
          dataIndex: "accountNumber",
          sorter: (a, b) =>
            (a.accountNumber || "").localeCompare(b.accountNumber || ""),
          render: (fileName, record) => {
            return record.accountNumber ? (
              <div>
                {record.accountVaired ? (
                  "Vaired"
                ) : (
                  <div>{"****" + record.accountNumber}</div>
                )}
              </div>
            ) : (
              "N/A"
            );
          },
        },
        {
          title: "Due",
          dataIndex: "dueDate",
          // render: (date) =>
          //   date
          //     ? new Date(date).toLocaleDateString("en-US", {
          //         year: "numeric",
          //         month: "2-digit",
          //         day: "2-digit",
          //       })
          //     : "N/A",
          sorter: (a, b) => getSortValue(a) - getSortValue(b),
          sortDirections: ["ascend", "descend"],
          render: (fileName, record) => {
            if (
              record.frequency &&
              record.frequency.toLowerCase() === "irregular"
            ) {
              return "Varied";
            }
            if (record.dueDate) {
              const status = calculateDueStatus(record);

              if (status.toLowerCase() === "expired") {
                return <span style={{ color: "red" }}>{status}</span>;
              }

              return status;
            }

            return "N/A";
          },
        },
        {
          title: "Status",
          dataIndex: "status",
          render: (record) => {
            return (
              <div
                style={{
                  color:
                    record.frequency &&
                    record.frequency.toLowerCase() === "irregular"
                      ? "red"
                      : "#2a3da3",
                  fontStyle:
                    record.frequency &&
                    record.frequency.toLowerCase() === "irregular" &&
                    "italic",
                  fontWeight: "bold",
                }}>
                {record && record}
              </div>
            );
          },
        },
        {
          title: "Actions",
          dataIndex: "actions",
          render: (fileName, record) => {
            return (
              <>
                <Dropdown
                  trigger={["click"]}
                  overlay={
                    <Menu>
                      {record && record.status.toLowerCase() !== "confirmed" && <Menu.Item>
                        <div
                          onClick={() => {
                            hideRecurringTransaction(record.id,currentPage);
                            // setShareModal(true);
                            // setUpdateObject(data);
                          }}>
                          Hide
                        </div>
                      </Menu.Item>}
                       {record && record.status.toLowerCase() === "confirmed" && <Menu.Item>
                        <div
                        onClick={() => {
                          if (record && record.id) {
                            // handleClick(data.fileUrl);
                            if(record.status.toLowerCase() !== "confirmed"){
                              deleteRecurringTransaction(record.id)
                            }else{
                              deleteToken(record.id)
                            }
                          }
                        }}
                        >
                          Delete
                        </div>
                      </Menu.Item>}
                      <Menu.Item>
                      <div
                        onClick={() => {
                          if(record.status.toLowerCase() === "confirmed"){
                            setFormData(record);
                            setPattrenModal(true)
                          }else{
                            getSelectedRecords(record);
                            setModalTitle(record.status.toLowerCase() === "confirmed" ? "Edit Rule" : "Add Rule");
                            record.status.toLowerCase() !== "confirmed" && setAddModal(true); // Always open modal
                            // setFormData(record); // If needed, prefill with record

                          }
                        }}
                      >
                        {record.status.toLowerCase() === "confirmed" ? "Edit Rule" : "Add Rule"}
                      </div>
                    </Menu.Item>
                    </Menu>
                  }>
                  <a
                    className="ant-dropdown-link"
                    style={{ padding: "0px 8px" }}
                    // onClick={(e) => e.preventDefault()}
                  >
                    <img
                      className="imgIcon"
                      src={menuIcon}
                      height={15}
                      width={4}
                      alt="icon"></img>
                  </a>
                </Dropdown>
              </>
            );
          },
        },
      ];

      const handleInputChange = (name, value) => {
        setFormData({
          ...formData,
          [name]: value,
        });
      };

      const handleCancelPattren = () => {
        setAddModal(false);
        setFormData(null);
        setFetchRecuuring(!fetchRecuuring);
        setModalTitle("Add Rule");
      };

      const updatePreviousTransactions = async (payload) => {
        try {
          setLoading(true);
          const id = payload.id;
          let data = await BUDGET_API.updatePreviousTransactionsForRecurring(id);
          console.log("datadata", data);
          setFetchRecuuring(!fetchRecuuring);
          setRecurring(!recurring);
          if (data && data.success) {
            swal(
              "Success",
              "Rule Pattern Applied to Existing Transactions",
              "success"
            );
          }
          if (data && data.statusCode === 400) {
            swal("Error", data.message, "error");
          }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      };
      const updateStateWithData = (datares) => {
        console.log("datares", datares);
        if (datares && datares.body.data) {
          const sortedData = [...datares.body.data].sort((a, b) => {
            if (a.priority !== undefined && b.priority !== undefined) {
              return a.priority - b.priority;
            }
            return 0; // Keep original order if priority doesn't exist
          });
          setRecurringTokens(sortedData);
        }
        if (datares && datares.body) {
          setTotalPages(Math.ceil(datares.body.totalPages));
        }
      };

      const getRecurringTokenAfterDelete = async (page) => {
        try {
          setLoading(true);
          let data = await BUDGET_API.fetchRecurringToken(page);
          if (data && data.body) {
            setCachedData((prevState) => ({
              ...prevState,
              [page]: data,
            }));
            updateStateWithData(data);
            console.log("alldata", data.body);
          }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      };

      const createRecuuringTransactions = async (payloadData) => {
        try {
          setLoading(true);
          const selectedTransactionsIds= payloadData.selectedTransactions && payloadData.selectedTransactions.map((row) => row.id);
          // OLD PAYLOAD
          // const payload={
          //   tokenId : payloadData.tokenId,
          //   patternId : payloadData.patternId,
          //   transactionIds:selectedTransactionsIds,
          // }
          const payload = (selectAll || payloadData.selectAll)
        ? {
            tokenId: payloadData.tokenId,
            patternId: payloadData.patternId,
            selectAll: true,
          }
        : {
            tokenId: payloadData.tokenId,
            patternId: payloadData.patternId,
            transactionIds: selectedTransactionsIds,
          };
    
          let data = await BUDGET_API.createTransactionsForRecurring(payload);
          setFetchRecuuring(!fetchRecuuring);
          setRecurring(!recurring);
          if (data && data.success) {
            swal("Success", data.message || "Recurring Transactions Created!", "success");
          }
          if (data && data.statusCode === 400) {
            swal("Error", data.message, "error");
          }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      };

      const handleSavePattren = async (selectedTransactions, updatedPatterns) => {
        const finalPatterns = updatedPatterns ;
        setAddModal(false);
        if (modalTitle === "Add Rule") {
          try {
            let payload = {
              ...formData,
              patterns:updatedPatterns
            };
        // OLD PAYLOAD..
        // console.log("formData", formData);Add commentMore actions
        // setAddModal(false);
        // if (modalTitle === "Add Rule") {
        //   try {
        //     let payload = {
        //       ...formData,
        //     };
    
            setLoading(true);
            let data = await BUDGET_API.addRecurringToken(payload);
            console.log("data token", data);
            setFetchRecuuring(!fetchRecuuring);
            
            if (data && data.statusCode === 201) {
              swal("Success", data.message, "success");
              await getRecurringTokenAfterDelete(1);
              setFetchRecuuring(!fetchRecuuring);
              const payloadData={
                tokenId : data.data.token.id,
                patternId : data.data.patterns && data.data.patterns[0].id,
                selectedTransactions:selectedObject,
              }
              console.log("payloadData",payloadData)
              await createRecuuringTransactions(payloadData);
              if (formData && formData.applyRuleToExistingTransactions) {
                console.log('dda',data.data)
                await updatePreviousTransactions(data.data.token);
              }
              
              
            }
            if (data && data.statusCode === 400) {
              swal("Error", data.message, "error");
            }
            await deleteRecurringTransaction(selectecPrediction.id)
            fetchSystemRecurringPages()
            setLoading(false);
          } catch (error) {
            console.log(error);
            setLoading(false);
          }
        }
        setFormData(null);
        setModalTitle("Add Rule");
      };

      const handleCancelPattrenUpdate = async () => {
        setPattrenModal(false);
        setFormData(null);
        setFetchRecuuring(!fetchRecuuring);
        await getRecurringTokenAfterDelete(1);
      };

      // const handleUpdateTokenPattren = async (payload) => {
      //     try {
      //       setLoading(true);
      //       console.log("formData", payload);
      //       const payloadUpdate={
      //         tokenId : payload.tokenId,
      //         patternId : payload.patternId,
      //         pattern	: payload.pattern,
      //       }
      //       let data = await BUDGET_API.updateRecurringTokenPattren(payloadUpdate);
      //       // const payloadData={
      //       //   tokenId : payload.tokenId,
      //       //   patternId : payload.patternId,
      //       //   selectedTransactions:payload.selectedTransactions,
      //       // }
      //       const payloadData = payload && payload.selectAll
      //     ? {
      //         tokenId: payloadUpdate.tokenId,
      //         patternId: payloadUpdate.patternId,
      //         selectAll: true,
      //       }
      //     : {
      //         tokenId: payloadUpdate.tokenId,
      //         patternId: payloadUpdate.patternId,
      //         selectedTransactions:payload.selectedTransactions,
      //       };
      //       await createRecuuringTransactions(payloadData);
      //       setFetchRecuuring(!fetchRecuuring);
      //       // if (data && data.status === 200) {
      //       //   swal("Success", data.message, "success");
      //       //   await getRecurringToken();
      //       // }
      //       setLoading(false);
      //     } catch (error) {
      //       console.log(error);
      //       setLoading(false);
      //     }
      //   };

      const handleUpdateTokenPattren = async (payload) => {
        try {
          setLoading(true);
          console.log("formData", payload);
          const payloadUpdate={
            tokenId : payload.tokenId,
            patternId : payload.patternId,
            pattern	: payload.pattern,
          }
          let data = await BUDGET_API.updateRecurringTokenPattren(payloadUpdate);
          // const payloadData={
          //   tokenId : payload.tokenId,
          //   patternId : payload.patternId,
          //   selectedTransactions:payload.selectedTransactions,
          // }
          const payloadData = payload && payload.selectAll
        ? {
            tokenId: payloadUpdate.tokenId,
            patternId: payloadUpdate.patternId,
            selectAll: true,
          }
        : {
            tokenId: payloadUpdate.tokenId,
            patternId: payloadUpdate.patternId,
            selectedTransactions:payload.selectedTransactions,
          };
          await createRecuuringTransactions(payloadData);
          await fetchSystemRecurringPages();
          setFetchRecuuring(!fetchRecuuring);
          // if (data && data.status === 200) {
          //   swal("Success", data.message, "success");
          //   await getRecurringToken();
          // }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      };

        const handleUpdateToken = async () => {
          console.log("formData", formData);
          setTokenModal(false);
          try {
            setLoading(true);
            let payload = {
              token: formData && formData.token,
              tokenId: formData && formData.id,
            };
            let data = await BUDGET_API.updateRecurringToken(payload);
            setFetchRecuuring(!fetchRecuuring);
            if (data && data.statusCode === 200) {
              swal("Success", data.message, "success");
              await getRecurringTokenAfterDelete(1);
              await fetchSystemRecurringPages();
            }
            setLoading(false);
          } catch (error) {
            console.log(error);
            setLoading(false);
          }
          setFormData(null);
        };

        const handleDeletePattren = async (payload) => {
          swal({
            title: "Are you sure?",
            text: "Are you sure you want to delete this Recurring Rule Pattern?",
            dangerMode: true,
            buttons: ["No, cancel it!", "Yes, Delete it!"],
            icon: "warning",
            type: "warning",
            closeOnConfirm: false,
            closeOnCancel: false,
          }).then(async function (isConfirm) {
            // Redirect the user
            if (isConfirm) {
              try {
                setLoading(true);
                // let payload={tokenId:id,patternId:id}
                const res = await BUDGET_API.deleteRecurringTokenPattern(payload);
                if (res && res.statusCode === 200) {
                  await getRecurringTokenAfterDelete(1);
                  setFetchRecuuring(!fetchRecuuring);
                  swal(
                    "Deleted!",
                    "Your Recurring Rule Pattern has been deleted.",
                    "success"
                  );
                }
                setLoading(false);
              } catch (error) {
                console.log(error);
                setLoading(false);
              }
            } else {
              swal("Cancelled", "Your Recurring Rule Pattern is safe :)", "error");
            }
          });
        };

        const updatePreviousTransactionsPattren = async (payload) => {
          try {
            setLoading(true);
            const tokenId = payload.tokenId;
            const patternId = payload.id;
      
            let data = await BUDGET_API.updatePreviousTransactionsForRecurring(
              tokenId,
              patternId
            );
            setFetchRecuuring(!fetchRecuuring);
            setRecurring(!recurring);
            if (data && data.success) {
              swal("Success", "Rule Pattern to Existing Transactions", "success");
            }
            if (data && data.statusCode === 400) {
              swal("Error", data.message, "error");
            }
            setLoading(false);
          } catch (error) {
            console.log(error);
            setLoading(false);
          }
        };

        const handleSaveAddPattren = async (payload) => {
          try {
            setLoading(true);
            let data = await BUDGET_API.addRecurringTokenPattren(payload);
            if (data && data.statusCode === 200) {
              setLoading(false);
              console.log("pattren data", data.body.result);
              swal({
                title: "Are you sure?",
                text: "Are you sure you want to apply this Rule Pattern to Existing Transactions.",
                icon: "warning",
                type: "warning",
                buttons: {
                  upgrade: {
                    text: "No",
                    value: "upgrade",
                    visible: true,
                  },
                  ok: {
                    text: "Yes",
                    value: "ok",
                    visible: true,
                  },
                },
              }).then((value) => {
                console.log("Button value clicked:", value); // Debugging line to show the value
                switch (value) {
                  case "upgrade":
                    console.log("calling upgrade");
                    // updatePayment();
                    break;
      
                  case "ok":
                    console.log("calling ok");
                    updatePreviousTransactionsPattren(data.body.result);
                    break;
      
                  default:
                    console.log("No action taken");
                    break;
                }
              });
              return data;
              // await getRecurringTokenAfterDelete(1);
            }
            if (data && data.statusCode === 400) {
              swal("Error", data.message, "error");
            }
            setLoading(false);
          } catch (error) {
            console.log(error);
            setLoading(false);
          }
        };
        

      
  return (
    <div>
      <div className="tableContainer">
        <Table
          columns={cols}
          // dataSource={unifiedList && unifiedList}
          // pagination={{
          //    total: totalPages * 10, // Assuming 10 items per page
          //   // current: currentPage,
          //   // onChange: (page) => {
          //   //   setCurrentPage(page);
          //   // },
          //   pageSize: 20, // Number of items per page
          // }}
          rowKey="id"
          rowSelection={{
            type: "checkbox",
            selectedRowKeys: selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) =>  {
              console.log("selectedRowKeys:", selectedRowKeys);
              console.log("selectedRows:", selectedRows);
              selectedRowsDataKeys(selectedRowKeys);
            },
            getCheckboxProps: (record) => ({
            disabled: record && record.status && record.status.toLowerCase() === "confirmed", // condition here
          }),
          }}
          dataSource={displayList} 
          pagination={{
            total: systemTotalPages * 10 + (allTransactions ? allTransactions.length : 0),
            current: currentPage,
            onChange: (page) => setCurrentPage(page),
            pageSize: PAGE_SIZE,
          }}
        />
      </div>
      <Modal
        visible={detailsModal}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        centered
      >
        <h3 className="modaltitle">Transaction Details</h3>
        <h3 className="modaltitle">
          {(selectecPrediction && typeof selectecPrediction.status === "string")
          ? (selectecPrediction.status.toLowerCase() === "confirmed"
              ? totalTokenRecords
              : selectedObject.length)
          : 0} Transactions
        </h3>

        <div>
          <div
            className=""
            style={{ height: "18rem", maxHeight: "18rem", overflow: "auto" }}
            id="transactions-main"
            onScroll={handleScroll}
          >
            {sortedData && sortedData.length > 0 ? (
              <table id="clients">
                <thead>
                  <tr>
                    <th
                      onClick={() => handleSort("date")}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      Date {renderSortIcon("date")}
                    </th>
                    <th>Name</th>
                    <th>Category</th>
                    <th
                      onClick={() => handleSort("amount")}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      Amount {renderSortIcon("amount")}
                    </th>
                  </tr>
                </thead>
                <tbody style={{}}>
                  {sortedData &&
                    sortedData.map((data, index) => (
                      <tr key={index}>
                        <td>
                          {data.date && data.date
                            ? moment(data.date).format("MM-DD-YYYY")
                            : "N/A"}
                        </td>
                        <td>
                          {data.itemName && data.itemName
                            ? data.itemName
                            : "N/A"}
                        </td>
                        <td>
                          {data &&
                          data.categoryFromPlaid
                            ? data.categoryFromPlaid
                            : "N/A"}
                        </td>
                        <td>
                          {" "}
                          ${" "}
                          {data && data.amount
                            ? `${data.amount
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                            : "0"}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            ) : (
              <h3 className="inputTitle">No Transaction to Show</h3>
            )}
          </div>
        </div>
      <NewLoader isLoading={loading} />

        <div className="buttonsMain" style={{ justifyContent: "center" }}>
          <button
            className="savebutton"
            onClick={() => {
              handleCancel();
            }}
          >
            Close
          </button>
        </div>
      </Modal>
      {addModal && (
              <AddRecurringPatternModalFromTable
                title={modalTitle && modalTitle}
                open={addModal}
                handleChange={handleInputChange}
                handleCancel={handleCancelPattren}
                data={formData && formData}
                handleSave={handleSavePattren}
                selectAll={selectAll}
                setSelectAll={setSelectAll}
                selectedObject={selectedObject}
                selectecPrediction={selectecPrediction}
              />
            )}
      {pattrenModal && (
              <EditRecurringPatternModalFromTable
                open={pattrenModal}
                handleChange={handleInputChange}
                handleCancel={handleCancelPattrenUpdate}
                data={formData && formData}
                handleSave={handleUpdateTokenPattren}
                handleSaveRule={handleUpdateToken}
                handleDelete={handleDeletePattren}
                handleSaveAddPattren={handleSaveAddPattren}
                loading={loading}
              />
            )}
      <NewLoader isLoading={loading} />
    </div>
  );
}

export default RecurringCombined